import {
  ArrowRightIcon,
  LightningBoltIcon,
  OfficeBuildingIcon,
  ShieldCheckIcon,
} from "@heroicons/react/solid";
import React from "react";
import { audiences } from "../data";

const icons = [LightningBoltIcon, OfficeBuildingIcon, ShieldCheckIcon];

export default function WhoWeHelp() {
  return (
    <section id="who-we-help" className="bg-purple-900 text-white">
      <div className="container px-5 py-16 mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold title-font text-white mb-4">
            Who We Help
          </h1>
          <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-purple-200">
            Founders, growing businesses, and financial services companies,
            each with a different starting problem.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {audiences.map((audience, index) => {
            const Icon = icons[index];
            return (
              <div
                key={audience.segment}
                className="bg-purple-800 rounded-xl p-8 border border-purple-700 flex flex-col"
              >
                <div className="w-12 h-12 rounded-xl bg-purple-700 flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-purple-200" />
                </div>
                <p className="text-purple-300 text-xs uppercase tracking-widest font-semibold mb-3">
                  {audience.segment}
                </p>
                <h2 className="text-white text-xl title-font font-medium mb-3">
                  {audience.from}
                </h2>
                <p className="text-purple-200 text-sm leading-relaxed mb-6">
                  {audience.description}
                </p>
                <a
                  href="#contact"
                  className="mt-auto inline-flex items-center text-white text-sm font-medium hover:text-purple-200"
                >
                  Get in touch
                  <ArrowRightIcon className="w-4 h-4 ml-1" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
